import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  TableCell,
  TableRow,
  Link,
} from '@material-ui/core';
import LineReceptionCustomer from '../../pages/dashBoard/lineReceptionCustomer';
import { getEnvVariable } from '../../../commonFunction/getEnv';
import UserLevel from '../../eleCommon/userLevel';

const useStyles = makeStyles((theme) => ({
  tableRow: {
    '&:nth-child(even)': {
      background: '#F3F3F3',
    },
    '&.expired': {
      background: 'rgba(216, 52, 32, 0.08)!important',
    },
    '&.Mui-selected': {
      background: `${theme.palette.primaryColor}29!important`,
    },
    '&:hover': {
      background: `${theme.palette.primaryColor}29!important`,
    },
  },
  tableTd: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: '13px',
    lineHeight: '1.6',
    padding: '6px 4px',
    borderBottom: '1px solid #8C8C8C',
    height: 52,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    '&:nth-child(1)': { width: 40, maxWidth: 40, minWidth: 40 },
    '&:nth-child(2)': { width: 140, maxWidth: 140, minWidth: 140 },
    '&:nth-child(3)': { width: 70, maxWidth: 70, minWidth: 70 },
    '&:nth-child(4)': { width: 280, maxWidth: 280, minWidth: 280 },
    '&:nth-child(5)': { width: 100, maxWidth: 100, minWidth: 100 },
    '&:nth-child(6)': { width: 280, maxWidth: 280, minWidth: 280 },
    '&:nth-child(7)': { width: 100, maxWidth: 100, minWidth: 100 },
    '&:nth-child(8)': { width: 100, maxWidth: 100, minWidth: 100 },
    '&:nth-child(9)': { width: 100, maxWidth: 100, minWidth: 100 },
    '&:nth-child(10)': { width: 200, maxWidth: 200, minWidth: 200 },
    '&:nth-child(11)': { width: 100, maxWidth: 100, minWidth: 100 },
  },
  wishAreaCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

/**
 * 受信日時が「〇〇分前」形式かどうかを判定する
 * @param {string} lastReceivedAt
 * @returns {boolean}
 */
const isWithinOneHour = (lastReceivedAt) => {
  if (!lastReceivedAt) return false;
  // 文字列に「分前」が含まれているか判定
  return lastReceivedAt.includes('分前');
};

export default function LineReceptionTableRowWrapper(props) {
  const { index, style, row } = props;
  const classes = useStyles();
  const { customer } = row;
  return (
    <TableRow
      hover
      tabIndex={-1}
      className={classes.tableRow}
      style={style}
    >
      <TableCell className={classes.tableTd} align="center">
        {index + 1}
      </TableCell>
      <TableCell
        className={classes.tableTd}
        style={{
          color: isWithinOneHour(row.lastReceivedAt) ? '#ff0000' : 'inherit',
        }}
      >
        {row.lastReceivedAt}
      </TableCell>
      <TableCell className={classes.tableTd}>
        {customer.id}
      </TableCell>
      <TableCell className={classes.tableTd}>
        <LineReceptionCustomer
          id={customer.id}
          fullName={customer.fullName || ''}
          memberStatus={customer.memberStatusCode}
          customerStatus={customer.status}
          memberId={customer.memberId}
        />
      </TableCell>
      <TableCell className={classes.tableTd}>
        <Link
          href={getEnvVariable('LINE_URL') + customer.hashCustomerId}
          target="_blank"
          color="primary"
        >
          LINEリンク
        </Link>
      </TableCell>
      <TableCell
        className={classes.tableTd}
        style={{ justifyContent: 'flex-start' }}
      >
        {row.user}
      </TableCell>
      <TableCell className={classes.tableTd}>
        <UserLevel code={row.customer.userLevel} />
      </TableCell>
      <TableCell className={classes.tableTd}>
        {customer.detachedHouseBudgetMax}
      </TableCell>
      <TableCell className={classes.tableTd}>
        {customer.landBudgetMax}
      </TableCell>
      <TableCell
        className={`${classes.tableTd} ${classes.wishAreaCell}`}
        style={{ justifyContent: 'flex-start' }}
        title={customer.wishArea}
      >
        {customer.wishArea}
      </TableCell>
      <TableCell className={classes.tableTd}>
        {customer.annualIncome}
      </TableCell>
    </TableRow>
  );
}
